import React from 'react'
import 'react-tooltip/dist/react-tooltip.css'
import '../styles/checkBox2.css'

const CheckBox2 = (props) => {

  return (
    <div className="check2" style={{display: 'flex',  justifyContent: 'center' }} >
      <input onChange={props.onChange} id={props.id} name={props.id} defaultChecked={props.default} checked={props.checked} type='checkbox' />
      <label htmlFor={props.id} >
        <span></span> 
      </label>
    </div>
  )

}

export default CheckBox2;